import React from "react";
import SectionHead from "../common/SectionHead";
import { skillGroups, tools } from "../../data/content";

function Chips({ items }) {
  return (
    <ul className="chip-list">
      {items.map((item) => (
        <li className="chip" key={item}>
          {item}
        </li>
      ))}
    </ul>
  );
}

function Skills() {
  return (
    <section className="section" id="skills">
      <div className="container">
        <SectionHead eyebrow="Skills" title="Professional Skillset" />

        {skillGroups.map(({ title, items }) => (
          <div className="skills__row" key={title}>
            <h3 className="skills__row-title">{title}</h3>
            <Chips items={items} />
          </div>
        ))}

        <div className="skills__group">
          <h3 className="skills__label">Tools I use</h3>
          <Chips items={tools} />
        </div>
      </div>
    </section>
  );
}

export default Skills;
